import { render, staticRenderFns } from "./Choices.vue?vue&type=template&id=a7c5c928&scoped=true"
import script from "./Choices.vue?vue&type=script&lang=js"
export * from "./Choices.vue?vue&type=script&lang=js"
import style0 from "./Choices.vue?vue&type=style&index=0&id=a7c5c928&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7c5c928",
  null
  
)

export default component.exports